var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Exchange Rates (Avg & Spot)",
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "width": "870px",
      "top": "5vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "formRef",
    staticClass: "pb20",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataFormRules,
      "label-position": "right"
    }
  }, [_c('div', {
    staticClass: "flex jcsb"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('el-form-item', {
    staticClass: "mr10",
    attrs: {
      "prop": "monthrange"
    }
  }, [_c('el-date-picker', {
    staticClass: "wd250",
    attrs: {
      "type": "monthrange",
      "range-separator": "~",
      "start-placeholder": "Start month",
      "end-placeholder": "End month",
      "value-format": "yyyyMM"
    },
    model: {
      value: _vm.dataForm.monthrange,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "monthrange", $$v);
      },
      expression: "dataForm.monthrange"
    }
  })], 1), _c('el-form-item', {
    staticClass: "mr10",
    attrs: {
      "prop": "baseCurrency"
    }
  }, [_c('el-select', {
    staticClass: "wd200",
    attrs: {
      "placeholder": "Base Currency",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: _vm.dataForm.baseCurrency,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "baseCurrency", $$v);
      },
      expression: "dataForm.baseCurrency"
    }
  }, _vm._l(_vm.exRateCurrencyExclusiveList, function (item) {
    return _c('el-option', {
      key: item.currency,
      attrs: {
        "label": item.currency,
        "value": item.currency
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "prop": "targetCurrency"
    }
  }, [_c('el-select', {
    staticClass: "wd200",
    attrs: {
      "placeholder": "Target Currency",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: _vm.dataForm.targetCurrency,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "targetCurrency", $$v);
      },
      expression: "dataForm.targetCurrency"
    }
  }, _vm._l(_vm.exRateCurrencyExclusiveList, function (item) {
    return _c('el-option', {
      key: item.currency,
      attrs: {
        "label": item.currency,
        "value": item.currency
      }
    });
  }), 1)], 1)], 1), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": function click($event) {
        return _vm.submitForm('dataForm');
      }
    }
  }, [_vm._v("Generate")])], 1)]), _c('div', {
    staticClass: "contentHead"
  }, [_c('p', [_vm._v(" Average exchange rate: "), _c('span', {
    staticClass: "ml6 black"
  }, [_vm._v(_vm._s(_vm.averageVal))])]), _c('p', [_vm._v(" Sport rate at the period end: "), _c('span', {
    staticClass: "ml6 black"
  }, [_vm._v(_vm._s(_vm.sportVal))])])])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }